var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarLeaderboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8184 8.52157C13.9319 6.55587 12.6407 3.12325 11.9998 0C11.358 3.12388 10.0682 6.55722 8.18097 8.52292C6.29446 10.4873 2.99791 11.8322 0 12.501C2.99914 13.1685 6.29507 14.5127 8.18159 16.4784C10.0681 18.4434 11.3594 21.8768 12.0011 25C12.642 21.8761 13.9328 18.4428 15.819 16.4771C17.7055 14.5121 21.0021 13.1678 24 12.499C21.0015 11.8315 17.7056 10.4866 15.8184 8.52157Z",
    fill: "#BDCBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarLeaderboard);
export default __webpack_public_path__ + "static/media/starLeaderboard.b9e4a4cd741ae1d904e6e42bf87f63e3.svg";
export { ForwardRef as ReactComponent };